import { Box } from '@cdl/heartbeat-react';
import React from 'react';

interface Props {
  height: number;
  timestamp: number;
}

export const RulerLine: React.FC<Props> = ({ timestamp, height }) => {
  return (
    <Box
      as='rect'
      x={timestamp}
      fill='neutral.300'
      width='0.125rem'
      height={height}
    />
  );
};
